import CloseIcon from "@mui/icons-material/Close";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Dialog,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableCell,
  TableRow,
  TextField,
  TableBody,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { upperCase } from "lodash";
import React, { useState, useEffect } from "react";
import { useMessages } from "./MessagesContext";
import { createMessage, deleteMessage, saveMessage } from "./utils";

const MessageForm = () => {
  const [open, setOpen] = useState(false);
  const {
    message,
    filterValues,
    selectedMessage,
    setSelectedMessage,
    setReload,
    setMessage
  } = useMessages();

  useEffect(() => {
    setOpen(selectedMessage !== null || message!==null);
  }, [selectedMessage,message]);

  const handleChange = (e) => {
    const name = e.target.name.toLowerCase();
    const value = e.target.value;
    setMessage((prev) => ({ ...prev, [name]: value }));
  };

  const saveMsg = (selectedMessage) => {
    if(selectedMessage.id===null)
      createMessage(selectedMessage).then(() => {
        setSelectedMessage(null);
        setMessage(null);
        setReload(true);
      });
    else  
    saveMessage(selectedMessage).then(() => {
        setSelectedMessage(null);
        setMessage(null);
        setReload(true);
    });
  };

  const deleteMsg = (selectedMessage) => {
    deleteMessage(selectedMessage).then(() => {
        setSelectedMessage(null);
        setMessage(null);
        setReload(true);
    });
  };

  const onClose = (e, reason) => {
    setSelectedMessage(null);
    setMessage(null);
  };
  console.log("message--->"+JSON.stringify(message))
  var title="New Message"
  if(message){
        if(message.id)
            title="Edit Message"
  }
  return (
    message && (
      <Dialog fullWidth maxWidth="true" open={open} onClose={onClose}>
        <IconButton
          aria-label="close"
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            // color: (theme) => theme.palette.grey[1500],
          }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
        {/* <Card sx={{ overflow: "auto" }}> */}
        <Card sx={{ borderRadius: 3 }}>
          <CardHeader
            title={<font className="layer-title"> {title} </font>}
            align="center"
            className={"styledtablerow"}
          />
          <DescriptionBlock/>
          <CardContent
            sx={{
              paddingTop: 1,
              paddingLeft: 0,
              paddingRight: 0,
              overflow: "auto",
            }}
          >
            <Box maxWidth= '1000px'sx={{paddingTop:3, paddingLeft:2, align:'center', marginLeft:55}} border={1}>
              <Grid container spacing={{ xs: 1}}  justifyContent={"space-between"}>
                <Grid alignItems={"stretch"}>
                  <Table size="small">
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        ID
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        {message.id}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        AMBER ALERT
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        <Checkbox
                          checked={message.amberAlert}
                          onChange={(e) => {
                            setMessage((message) => {
                              return {
                                ...message,
                                amberAlert: !message.amberAlert,
                              };
                            });
                          }}
                        // name="agency"
                        // value={message.amberAlert}
                        // onChange={handleChange}
                      />
                      </TableCell>
                    </TableRow>
                    
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        PRIORITY
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        <Select size="small"
                          labelId="messagePriority-label"
                          id="priority-selection"
                          value={message.priority}
                          // label="Priority"
                          onChange={handleChange}
                          name="Priority"
                          >
                          {filterValues.priorities.map((eachpriority) => (
                          <MenuItem
                          value={upperCase(eachpriority)}
                          key={upperCase(eachpriority)}
                        >
                        {upperCase(eachpriority)}{" "}
                        </MenuItem>
                        ))}
                        </Select>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
                <Grid xs={6}>
                  <Table size="small">
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        CREATED DATE
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        <DatePicker
                          value={message.startDate}
                          onChange={(newValue) => {
                            setMessage((message) => {
                              return { ...message, startDate: newValue };
                            });
                          }}
                          renderInput={(params) => <TextField {...params} error={false}/>}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        START DATE
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        <DatePicker size="small"
                          value={message.startDate}
                          onChange={(newValue) => {
                          setMessage((message) => {
                          return { ...message, startDate: newValue };
                          });
                          }}
                          renderInput={(params) => <TextField {...params} error={false}/>}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={"styledtablerow"}>
                        EXPIRATION DATE
                      </TableCell>
                      <TableCell className={"tablecellnoborder"}>
                        <DatePicker
                        value={message.expirationDate}
                        onChange={(newValue) => {
                          setMessage((message) => {
                            return { ...message, expirationDate: newValue };
                          });
                        }}
                        renderInput={(params) => <TextField {...params} error={false}/>}
                      />
                      </TableCell>
                    </TableRow>
                    
                  </Table>
                </Grid>
              </Grid>
              <Box sx={{paddingRight:2, pt:1, pb:1}}>
                {/* <TableRow>
                <TableCell className={"styledtablerow"}>
                  Message Text
                </TableCell>
                <TableCell> */}
                <TextField  fullWidth className={"tablecellnoborder"}
                      name="text"
                      id="filled-messagetext-flexible"
                      label="Message Text "
                      variant="filled"
                      type="text"
                      value={message.text}
                      onChange={handleChange}
                    
                />
                {/* </TableCell> */}
                {/* </TableRow> */}
              </Box>
            </Box>
            
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="right">
                    <Button
                      name="Save Message"
                      label="Save Message"
                      variant="outlined"
                      size="small"
                      onClick={(e) => saveMsg(message)}
                    >
                      Save Message
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      name="Delete Message"
                      label="Delete Message"
                      variant="outlined"
                      size="small"
                      onClick={(e) => deleteMsg(message)}
                    >
                      Delete Message
                    </Button>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

const DescriptionBlock = () => {
  return (
    <Typography>
      <ul>
        <li>
          A title and some text are required for the Message, and an icon is required if there is a link.
        </li>
        <li>
          Enter the Expiration Date/Time in "mm/dd/yyyy hh:mm" format. For an Message with no Expiration Date/Time, clear that field.
        </li>
        <li>
          With respect to Message categories:
          <ul>
            <li>
              An Message must have a category, and High Priority page cannot be the only category.
            </li>
            <li>
              An Message cannot be more than one of Construction, Transit, and Weather. 
            </li>
            <li>
              A Construction or Weather Message can also be a News Item. A Transit Message cannot be a New Item. (A Message can be a News Item only.) 
            </li>
            <li>
              Any Message can also be High Priority Page (as appropriate).
            </li>
          </ul>
        </li>
        <li>
          The "Event ID" is the ID of a construction or special event associated with the Message.
        </li>
        <li>
          Icons may be uploaded on the Admin Web File Images page. Refresh this page to view newly uploaded icons and/or images.
        </li>
        {/* <li>
          If you add an image wider than 360 pixels to the HTML Text area, you must set class= "narrowOnMobile" on the image. To do so, press the "Source" button at the top left of the HTML editor to see the actual HTML. The HTML for the image begins with 
        </li> */}
      </ul>
    </Typography>
  )
};

export default MessageForm;
